/*** IMPORTS FROM imports-loader ***/
var define = false;

import emitter from '../../mixin/emitter'

export default {
  name: 'DatePickerInput',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  template: `
    <flat-pickr 
      :value="currentValue" 
      :config="flatpickrConfig"
      @on-change="handleChange"
      @on-close="handleClose"
    />
  `,

  props: {
    value: [String, Date],
  },

  data() {
    return {
      currentValue: this.value === undefined || this.value === null ? '' : this.value,
    }
  },

  computed: {
    flatpickrConfig() {
      return {
        altInput: true,
        altInputClass: 'ui-input__inner width--small flatpickr-input',
        onReady: (a, b, fp) => {
          if (fp.altInput) {
            fp.altInput.setAttribute('id', this.computedId)
          }
        },
      }
    },

    computedId() {
      if (this.id) {
        return this.id
      }

      return this.uiFormItem.computedId
    },
  },

  methods: {
    handleChange(selectedDates, dateStr) {
      this.$emit('input', dateStr)
      this.$emit('change', dateStr)
      this.dispatch('UiFormItem', 'ui.form.change', dateStr)
    },

    handleClose(selectedDates, dateStr) {
      this.dispatch('UiFormItem', 'ui.form.change', dateStr)
    },

    setCurrentValue(value) {
      this.currentValue = value
    },
  },
}

